import Vue from 'vue'
// import Vue from 'vue/dist/vue.js';
import VueRouter from 'vue-router'
import App from './App.vue'
import NotFound from './NotFound.vue'
// eslint-disable-next-line no-unused-vars
// import MainLayout from './layout/Main.vue'
import MainLayout from './layout/MainLayout.vue'
// import Test from './Test.vue'
// import {routes, simpleRoutes, App} from './routes.js'
// import {routes,  App} from './routes.js'
import axios from 'axios';
axios.defaults.baseURL = "https://cmd.akuma.cloud";
Vue.use(VueRouter);
// Vue.config.productionTip = false;
// 0. If using a module system (e.g. via vue-cli), import Vue and VueRouter
// and then call `Vue.use(VueRouter)`.

// 1. Define route components.
// These can be imported from other files
// const App = { template: '<app></app>' };
// const NotFound = { template: '<not-found></not-found>' };
// const Test = { template: '<test></test>' };

// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
// const routes = [
//     { path: '/', component: App, alias: ""},
//     { path: '/test', component: Test },
//     { path: '/xxx', component: Test },
//     { path: '/yyy', component: Test },
//     { path: '/about', component: NotFound },
//     { path: '/404', component: NotFound },
// ];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
    mode: 'history',
    routes: [
        {path: '/', component: App, alias: ""},
        // {path: '/test', component: Test},
        // {path: '/xxx', component: Test},
        // {path: '/yyy', component: Test},
        // {path: '/about', component: App},
        {path: '/404', component: NotFound},
        {path: "*", component: NotFound},
    ] // short for `routes: routes`
})

// 4. Create and mount the root instance.
// Make sure to inject the router with the router option to make the
// whole app router-aware.
// eslint-disable-next-line no-unused-vars{
// const app = new Vue({
new Vue({
    router,
    // eslint-disable-next-line no-unused-vars
    components: {MainLayout},
    template: '<main-layout><router-view></router-view></main-layout>'
}).$mount('#app');
